import { apiInstance } from "./apiInstance"
import { formInstance } from "./formInstance"
import { getChartDurationTypeFormat } from "./getDurationTypeFormat"
import { getStartAndEndTime } from "./getStartAndEndTime"
import { getUniqueID } from "./getUniqueID"
import { parseJwt } from "./parseJwt"
import { randomModalAnimationClasses } from "./randomModalAnimationClasses"
import { sleep } from "./sleep"
import { stateInstance } from "./stateInstance"

export const HELPER_FUNCTIONS = {
  apiInstance: apiInstance,
  getStartAndEndTime: getStartAndEndTime,
  formInstance: formInstance,
  stateInstance: stateInstance,
  parseJwt: parseJwt,
  getUniqueID: getUniqueID,
  randomModalAnimationClasses: randomModalAnimationClasses,
  sleep: sleep,
  getChartDurationTypeFormat: getChartDurationTypeFormat,
}